import { Trans, useLingui } from '@lingui/react/macro';

import IconStoreRepair from '@/icons/StoreRepair.svg';
import { BaseNotification } from '@/layouts/App/Navbar/NotificationList/components/BaseNotification/BaseNotification';
import { useArticleName } from '@/models/article';
import type { TNotificationOfType } from '@/models/notification';

export const ArticleRepairIssueReportedNotification = ({
  notification,
}: {
  notification: TNotificationOfType<'article_repair_issue_reported'>;
}) => {
  const { t } = useLingui();

  const articleName = useArticleName({ article: notification.article });
  const workshopName = notification.data.workshopName;

  return (
    <BaseNotification
      notificationLabel={t({
        id: 'notification.article-repair-issue-reported.label',
        message: `The workshop ${workshopName} has reported a repair issue on the item ${articleName}`,
      })}
      icon={<IconStoreRepair />}
      type="neutral"
      notification={notification}
      notificationHeader={() => (
        <Trans id="notification.article-repair-issue-reported">
          A repair issue has been reported
        </Trans>
      )}
    />
  );
};
